import React, { Component } from 'react';
import { getDatabaseTypes, saveSourceDB, testConn, getSourceDB } from '../../../services/dataSourceService';
import CustomLoader from '../../common/Loader';
import { SourceTypes } from '../../../constants/DatasourceTypes';
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../../config';
import { withRouter } from 'react-router-dom';
import { logActivity } from '../../../services/utilService';

class SourceDatabase extends Component {
	DatabaseTypes = [];

	constructor(props) {
		super(props);

		this.state = {
			DataSource_ID: this.props.DataSource_ID,
			DataSource_Type_ID: SourceTypes.Database,
			Database_Type_ID: 0,
			Connection_String: '',
			Description: '',
			loading: false,
			connected: 0,
		};
	}

	async componentDidMount() {
		this.setState({ loading: true });

		const { data: dbTypes } = await getDatabaseTypes();
		this.DatabaseTypes = dbTypes;

		const { data } = await getSourceDB(this.state.DataSource_ID);
		if (data.length > 0) {
			this.setState({ Database_Type_ID: data[0].Database_Type_ID });
			this.setState({ Connection_String: data[0].Connection_String });
			this.setState({ Description: data[0].Description });
		}

		this.setState({ loading: false });
	}

	handleChange = (input) => {
		let value = input.value;

		if (input.name === 'Database_Type_ID') {
			value = parseInt(value);
		}

		if (input.name !== 'Description') {
			this.setState({ connected: 0 });
		}

		this.setState({ [input.name]: value });
	};

	setConnClass = () => {
		const { connected } = this.state;
		if (connected === 1) {
			return 'form-control is-valid';
		} else if (connected === -1) {
			return 'form-control is-invalid';
		} else {
			return 'form-control';
		}
	};

	testConnection = async () => {
		const { Connection_String, DataSource_Type_ID, Description } = this.state;
		if (!Description || DataSource_Type_ID === 0) {
			toaster('error', 'Please fill in all fields before testing connection.');
			return;
		}

		const { data } = await testConn(Connection_String);
		if (data.includes('Error')) {
			this.setState({ connected: -1 });
			logActivity('/dataSourceSettings', 'DATASOURCE_DB_TESTCONNECTION_FAILED');
		} else {
			this.setState({ connected: 1 });
			logActivity('/dataSourceSettings', 'DATASOURCE_DB_TESTCONNECTION_SUCCESS');
		}
	};

	handleSave = async () => {
		const { history } = this.props;
		const { data } = await saveSourceDB(this.state);
		if (data.includes('Error')) {
			toaster('error', data);
			logActivity('/dataSourceSettings', 'DATASOURCE_DB_SAVE_FAILED');
		} else {
			toaster('success', data);
			logActivity('/dataSourceSettings', 'DATASOURCE_DB_SAVE_SUCCESS');
			history.push('/dataSource');			
		}
	};

	render() {
		const { Connection_String, Database_Type_ID, Description, loading } = this.state;
		if (loading) {
			return <CustomLoader loading={loading} />;
		}

		return (
			<React.Fragment>
				<div className='form-group'>
					<label className='small' htmlFor='Description'>
						Source Description
					</label>
					<input className='form-control' id='Description' name='Description' type='text' value={Description} onChange={(e) => this.handleChange(e.target)} />
				</div>

				<div className='form-group'>
					<label className='small' htmlFor='Database_Type'>
						Database Type
					</label>
					<select id='Database_Type' className='form-control' value={Database_Type_ID} name='Database_Type_ID' onChange={(e) => this.handleChange(e.target)}>
						<option value='0'>Select</option>
						{this.DatabaseTypes.map((type) => {
							return (
								<option key={type.Database_Type_ID} value={type.Database_Type_ID}>
									{type.Database_Type_Name}
								</option>
							);
						})}
					</select>
				</div>

				<div className='form-group'>
					<label className='small' htmlFor='connection_string'>
						Connection String
					</label>
					<input className={this.setConnClass()} id='connection_string' type='text' name='Connection_String' value={Connection_String} onChange={(e) => this.handleChange(e.target)} />
					<div className='small'>eg. Server=[ServerName];Database=[DB_Name];UID=[Username];PWD=[password]</div>
					<div className='valid-feedback'>connected.</div>
					<div className='invalid-feedback'>connection failed.</div>
				</div>

				<hr className='my-4' />
				<div className='d-flex justify-content-end'>
					{this.state.connected !== 1 && (
						<button className='btn btn-outline-success btn-sm' onClick={this.testConnection}>
							Test Connection
						</button>
					)}

					{this.state.connected === 1 && (
						<button className='btn btn-outline-primary btn-sm' onClick={this.handleSave}>
							Save
						</button>
					)}
				</div>
				<ToastContainer/>
			</React.Fragment>
		);
	}
}

export default withRouter(SourceDatabase);
